import AdminDashboard from "../pages/Admin/AdminDashboard/AdminDashboard";
import UserDeviceDashboard from "../pages/Admin/UserDashboard/UserDeviceDashboard";
import Admin from "../pages/Admin/Area";
import ChipsLogs from "../pages/Admin/Users/ProfileList/ChipsDetail/ChipLogs";
import ProfileList from "../pages/Admin/Users/ProfileList/ProfileList";
import Users from "../pages/Admin/Users/Users";
import Settings from "../pages/Premises/Settings";
import React from "react";
import StaticOtp from "../pages/Admin/StaticOtp";
import SendNotification from "../pages/Admin/SendNotification";
import SchedulesLogs from "../pages/Admin/SchedulesLogs";
import Firmware from "../pages/Admin/Firmware/Firmware";
import DebugDevice from "../pages/Admin/DebugDevice";
import Logs from "../pages/Admin/Logs";
import Backup from "../pages/Admin/Backup";
import DebugDetail from "../pages/Admin/DebugDetail";
import Testing from "../pages/Admin/Testing/Testing";
import TestingDetailsList from "../pages/Admin/Testing/TestingDetailsList";
import TestingDetailsOfDetails from "../pages/Admin/Testing/TestingDetailsOfDetails";
import DemoRoom from "../pages/Demo/DemoRoom";
import Templates from "../pages/Admin/templates";
import AirAnalytics from "../pages/Admin/AirAnalytics";
import AirSegment from "../pages/Admin/AirSegment";
import getStorageData from "../Utils/getStorageData";
import Leaderboard from "../pages/Admin/StreakLeaderboard/Leaderboard";

const userDetails = getStorageData()?.user;
//For master admin
const allowedUserIds = [
  "67f5f80adf5b24d780bfd24c",
  "67beb885cd36b805b571cc2d",
  "66e55cbba53f0003767e4b29",
];
const isUserAllowed = allowedUserIds.includes(userDetails?.id || "");

// for rnd debug user
const allowedDebugUserIds = [
  "6961f00c6fe340c3bed9137e",
  "6961efd46fe340c3bed9137d",
];
const isDebugUser = allowedDebugUserIds.includes(userDetails?.id || "");

const adminRoutes = isDebugUser
  ? [
      { path: "/debug-device", component: <DebugDevice /> },
      { path: "/debug-device-details/:slave", component: <DebugDetail /> },
      { path: "/settings", component: <Settings /> },
    ]
  : [
      // { path: "/premises", component: <Dashboard /> },
      // { path: "/sub-admins", component: <SubAdmins /> },
      // { path: "/service-person", component: <Service /> },
      { path: "/settings", component: <Settings /> },
      { path: "/search", component: <Users /> },
      { path: "/users/profile/:id", component: <ProfileList /> },
      { path: "/users/profile/device/:slaveId", component: <ChipsLogs /> },
      { path: "/area", component: <Admin /> },
      { path: "/dashboard/request-dashboard", component: <AdminDashboard /> },
      {
        path: "/dashboard/request-dashboard/device-dashboard",
        component: <UserDeviceDashboard />,
      },
      {
        path: "/dashboard/request-dashboard/streak-leaderboard",
        component: <Leaderboard />,
      },

      { path: "/static-otp", component: <StaticOtp /> },
      { path: "/send-notification", component: <SendNotification /> },
      { path: "/firmware", component: <Firmware /> },
      { path: "/schedules-logs", component: <SchedulesLogs /> },
      // { path: "/master", component: <Master /> },
      { path: "/debug-device", component: <DebugDevice /> },
      { path: "/debug-device-details/:slave", component: <DebugDetail /> },
      { path: "/logs", component: <Logs /> },

      ...(isUserAllowed
        ? [
            { path: "/templates", component: <Templates /> },
            { path: "/air-analytics", component: <AirAnalytics /> },
            { path: "/air-segment", component: <AirSegment /> },
            { path: "/backup", component: <Backup /> },
          ]
        : []),

      // { path: "/feedback", component: <Feedback /> },
      { path: "/testing", component: <Testing /> },
      {
        path: "/testing/details-of-testing/:id",
        component: <TestingDetailsList />,
      },
      {
        path: "/testing/testing-details-of-details/:id",
        component: <TestingDetailsOfDetails />,
      },
      { path: "/stanza-room", component: <DemoRoom /> },
      {
        path: "/health",
        component: (
          <div style={{ marginTop: "80px", marginLeft: "10px" }}>
            <pre>
              {JSON.stringify(
                {
                  status: 200,
                  message: "Airpanel Service working fine...",
                },
                null,
                2,
              )}
            </pre>
          </div>
        ),
      },
    ];

export { adminRoutes };
